import { IconsTypes } from 'components/icons';

export enum CustomersTypes {
  /// Not specified
  Unspecified = 0,
  /// Person (human)
  Person = 1,
  /// Company
  Company = 2,
}

export enum MaritalStatus {
  /// Not specified
  Unspecified = 0,
  /// Single (not married)
  Single = 1,
  /// Married
  Married = 2,
  /// Civil union
  CivilUnion = 3,
  /// Domestic non-legalized partnership
  DomesticPartnership = 4,
  /// Divorced
  Divorced = 5,
  /// Widowed
  Widowed = 6,
}

export interface GenerateFormItem {
  name: string;
  label?: string;
  rightText?: string;
  icon?: IconsTypes;
  formType: 'input' | 'select' | 'checkbox' | 'radio';
  inputType?: 'text' | 'number' | 'password';
  inputOnChange?: (event: any) => void;
  maxLength?: number;
  width?: { m?: number | string; t?: number | string; d?: number | string } | number | string;
  maxWidth?: { m?: number; t?: number; d?: number } | number;
  selectRemoveFirstOption?: boolean;
  selectFirstLabel?: string;
  selectFirstValue?: string | number;
  selectOptions?: { value: string | number; label: string | number }[];
  checkboxLabel?: string;
  radioDirection?: 'row' | 'column';
  radioOptions?: { value: string | number; label: string | number }[];
  inputNumberRemoveArrows?: boolean;
  disabled?: boolean;
  mask?: (obj: any) => void;
  hide?: boolean;
  before?: GenerateFormItem[];
  after?: GenerateFormItem[];
  placeholder?: string;
  value?: string | number;
}

export interface AccountItemState {
  customerUuid: string;
  accountLogin: string;
  accountName: string;
  accountRecoveryEmail: string;
  name: string;
  alias: string;
  customerType: CustomersTypes;
  birthOrFoundation: string;
  country: string;
  taxId: string;
  contactPhone: string;
  contactWhatsApp: string;
  internationalContactPhone: boolean;
  internationalContactWhatsApp: boolean;
  contactEmail: string;
  contactWebSiteUrl: string;
  socialLinkedIn: string;
  socialInstagram: string;
  socialFacebook: string;
  socialTwitter: string;
  notes: string;
  occupation: string;
  maritalStatus: MaritalStatus;
  addressAlias: string;
  addressCountry: string;
  addressTaxId: string;
  addressState: string;
  addressCity: string;
  addressNeighborhood: string;
  addressLine1: string;
  addressLine2: string;
  addressNumber: string;
  addressZipCode: string;
  addressContactName: string;
  addressContactPhone: string;
  addressContactWhatsApp: string;
  addressContactEmail: string;
  addressContactWebSiteUrl: string;
}

export interface AccountApiResponse extends AccountItemState {}

export interface AccountState {
  account: AccountItemState;
}

export interface UseAccountState {
  account: AccountItemState;
  setAccount: (account: AccountApiResponse) => void;
  clearAccount: () => void;
}
